/**
 * @name querySelectorAllAsArray
 *
 * @description Returns an array of all matches for a given query selector
 *
 * @example
 * import { querySelectorAllAsArray } from '@workbench/core';
 *
 * const allPrimaryButtons: Array<HTMLButton> = querySelectorAllAsArray<HTMLButton>('button.primary');
 */
const querySelectorAllAsArray = (baseEl, selector) => Array.from(baseEl.querySelectorAll(selector));

export { querySelectorAllAsArray as q };
